import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ViewBoard from './icon-view-board.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ViewBoard {...validProps} />;
}
SvgComponent.iconName = 'viewBoard';

export const ViewBoardIcon = svgIconWrapper(SvgComponent);
